export type CreateCheckoutSessionResponseData = { url: string };

export type SubscriptionPlan = {
  name: string;
  description: string;
  price: string;
  billingType: "monthly" | "yearly" | "semi-annual";
  features: string[];
  featured: boolean;
  cta: string;
  id: string;
};

// Tabela de planos só existe no front hoje — mudança de preço no Stripe
// dessincroniza UI e tracking. Fica num único lugar para o dia de mover pro
// backend (pendência registrada em #65/#70).
export const subscriptionPlans: SubscriptionPlan[] = [
  {
    name: "Mensal",
    description: "Cobrança mensal, flexibilidade total",
    price: "79,90",
    billingType: "monthly",
    features: [
      "Máxima flexibilidade",
      "Agenda online",
      "Prontuário eletrônico completo",
      "Múltiplas Anamneses",
      "Cadastro ilimitado de pacientes",
      "Em breve, novas atualizações...",
      "Suporte 24/7"
    ],
    featured: false,
    cta: "Escolher Mensal",
    id: "c9d280f7-b038-42c4-83c7-e2fd6bc33f5e"
  },
  {
    name: "Anual",
    description: "Assine por 12 meses e economize mais",
    price: "719,10",
    billingType: "yearly",
    features: [
      "Economize 25%",
      "Agenda online",
      "Prontuário eletrônico completo",
      "Múltiplas Anamneses",
      "Cadastro ilimitado de pacientes",
      "Em breve, novas atualizações...",
      "Suporte 24/7"
    ],
    featured: true,
    cta: "Escolher Anual",
    id: "6aeeff26-d8cc-489c-ab1c-7289844bafb9"
  },
  {
    name: "Semestral",
    description: "Pague a cada 6 meses e economize",
    price: "407,49",
    billingType: "semi-annual",
    features: [
      "Economize 15%",
      "Agenda online",
      "Prontuário eletrônico completo",
      "Múltiplas Anamneses",
      "Cadastro ilimitado de pacientes",
      "Em breve, novas atualizações...",
      "Suporte 24/7"
    ],
    featured: false,
    cta: "Escolher Semestral",
    id: "190054fe-868d-472f-a928-2f84960f4013"
  }
];

export function findSubscriptionPlanByPriceId(
  priceId: string
): SubscriptionPlan | undefined {
  return subscriptionPlans.find((plan) => plan.id === priceId);
}

export function parsePlanPrice(price: string): number {
  return Number(price.replace(/\./g, "").replace(",", "."));
}
